import React, { useEffect, useState } from 'react';
import {
  Box,
  DialogActions,
  DialogContentText,
  Divider,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as AddIcon } from '../../../../assets/common-assets/Add.svg';
import { ReactComponent as Trash } from '../../../../assets/allInvoice-assets/trash-2.svg';

import {
  AddTaxButton,
  AutocompleteTaxMapping,
  CustomCloseIcon,
  CustomDialogContentTax,
  DialogHeader,
  FormControlStyledComponent,
  InputAdornmentStyleComponent,
  InputGroup,
  OdooPopup,
  SaveButton,
  TallyPrimeContent,
  TaxDeleteIconButton,
  TaxGrid,
} from './utils';
import {
  createManualAuthCredential,
  getAllTaxes,
  updateCredentialData,
} from '../../../../services/exportApi';
import Toast from '../../utils/Toast';

const data = [
  {
    label: 'SGST 2.5%',
    taxRate: '2.5%',
    value: '',
    name: '',
  },
  {
    label: 'CGST 2.5%',
    taxRate: '2.5%',
    value: '',
    name: '',
  },
  {
    label: 'IGST 5%',
    taxRate: '5%',
    value: '',
    name: '',
  },
  {
    label: 'SGST 6%',
    taxRate: '6%',
    value: '',
    name: '',
  },
  {
    label: 'CGST 6%',
    taxRate: '6%',
    value: '',
    name: '',
  },
  {
    label: 'IGST 12%',
    taxRate: '12%',
    value: '',
    name: '',
  },
  {
    label: 'SGST 9%',
    taxRate: '9%',
    value: '',
    name: '',
  },
  {
    label: 'CGST 9%',
    taxRate: '9%',
    value: '',
    name: '',
  },
  {
    label: 'IGST 18%',
    taxRate: '18%',
    value: '',
    name: '',
  },
  {
    label: 'SGST 14%',
    taxRate: '14%',
    value: '',
    name: '',
  },
  {
    label: 'CGST 14%',
    taxRate: '14%',
    value: '',
    name: '',
  },
  {
    label: 'IGST 28%',
    taxRate: '28%',
    value: '',
    name: '',
  },
  {
    label: 'GST 0%',
    taxRate: '0%',
    value: '',
    name: '',
  },
  {
    label: 'GST 5%',
    taxRate: '5%',
    value: '',
    name: '',
  },
  {
    label: 'GST 12%',
    taxRate: '12%',
    value: '',
    name: '',
  },
  {
    label: 'GST 18%',
    taxRate: '18%',
    value: '',
    name: '',
  },
  {
    label: 'GST 28%',
    taxRate: '28%',
    value: '',
    name: '',
  },
];
const TaxMapping = React.memo(function TaxMapping(props) {
  const {
    exportType,
    credentialId,
    invoiceIds,
    handleNewAndExport,
    newCredential,
    isManual,
    documentExportFunc,
    openTaxPopup,
    closePopup,
    accountSetter,
    setLoader,
    isSetting,
    currentData,
    isEditing = false,
    setIsEditing,
  } = props;
  const filteredData =
    exportType === 'Zoho'
      ? data.filter(
          (item) =>
            !item.label.includes('SGST') && !item.label.includes('CGST'),
        )
      : data;
  const [activeStep] = useState(1);
  const steps = ['ADD ACCOUNT', 'MAP TAX'];
  const [taxData, setTaxData] = useState(filteredData);
  const [taxes, setTaxes] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [fieldValue, setFieldValue] = useState({
    label: '',
    taxRate: '',
  });

  const location = useLocation();
  const currentPath = location.pathname.includes('settings');

  const [error, setError] = useState(null);
  const [showTaxFields, setShowTaxFields] = useState(false);

  let actionLabel;

  if (isEditing) {
    actionLabel = 'Update';
  } else if (currentPath) {
    actionLabel = 'Add';
  } else {
    actionLabel = 'Export';
  }

  const handleNewTaxChange = () => {
    const taxRate = parseFloat(fieldValue.taxRate);

    if (fieldValue.label !== '' && fieldValue.taxRate !== '') {
      if (taxRate >= 0 && taxRate <= 100) {
        const isDuplicate = taxData.some(
          (item) => item.label === `${fieldValue.label} ${fieldValue.taxRate}%`,
        );

        if (isDuplicate) {
          Toast({
            message: 'This tax entry already exists.',
            variant: 'warning',
          });
        } else {
          const entry = [
            {
              label: `${fieldValue.label} ${fieldValue.taxRate}%`,
              taxRate: fieldValue.taxRate,
              value: '',
            },
          ];
          setTaxData((prev) => [...prev, ...entry]);
          setFieldValue({
            label: '',
            taxRate: '',
          });
        }
      } else {
        Toast({
          message: 'Tax rate must be between 0 and 100.',
          variant: 'warning',
        });
      }
    } else {
      Toast({
        message: 'Please fill in both label and tax rate.',
        variant: 'warning',
      });
    }
  };

  useEffect(() => {
    if (isEditing && currentData?.tax_mapping?.length > 0) {
      const newArray = taxData.map((item) => {
        const match = currentData.tax_mapping.find(
          (tax) => tax.label === item.label,
        );
        return match ? { ...item, value: match.value, name: match.name } : item;
      });
      setTaxData(newArray);
      setTaxes(currentData.tax_mapping);
    }
  }, [currentData]);
  const handleCloseTaxChange = () => {
    setShowTaxFields(false);
  };
  const handleDelete = (index) => {
    if (taxes.length > 0 && taxData[index].name) {
      const filterTaxData = taxes.filter(
        (elem) => elem.name !== taxData[index].name,
      );
      setTaxes(filterTaxData);
    }

    setTaxData((prevData) => {
      if (prevData.length > 1) {
        return prevData.filter((_, i) => i !== index);
      }
      setError('Cannot delete the last entry');
      return prevData;
    });
  };
  const handleAddTaxClick = () => {
    setShowTaxFields(true);
  };
  const getAllTaxValue = async () => {
    const payload = {
      exportOption: exportType,
      credentialId,
    };
    let tax = [];
    const result = await getAllTaxes(payload);
    if (result && result.length) {
      if (exportType === 'TallyPrime') {
        tax = result.map((elem) => ({
          value: elem.name,
          name: elem.name,
          tax_type: elem.name,
        }));
      } else if (exportType === 'Odoo') {
        tax = result.map((elem) => ({
          value: elem.name,
          name: elem.name,
          tax_type: elem.id,
        }));
      } else if (exportType === 'QuickBook') {
        tax = result.map((elem) => ({
          value: elem.Name,
          name: elem.Name,
          tax_type: elem.Id,
        }));
      } else if (exportType === 'Xero') {
        tax = result.map((elem) => ({
          value: elem.Name,
          name: elem.Name,
          tax_type: elem.TaxType,
        }));
      } else if (exportType === 'Zoho') {
        tax = result.map((elem) => ({
          value: elem.tax_name,
          name: elem.tax_name,
          tax_type: elem.tax_id,
        }));
      }
    }
    setTaxOptions(tax);
  };
  useEffect(() => {
    getAllTaxValue();
  }, []);
  const handleChangeTax = (value, item, index) => {
    if (value === null) {
      setTaxes((prevTaxes) =>
        prevTaxes.filter((tax) => tax.label !== item.label),
      );
    } else {
      const newTax = {
        value: value.tax_type,
        taxPercentage: item.taxRate,
        label: item.label,
        name: value.value,
      };
      setTaxes((prevTaxes) => {
        const exists = prevTaxes.some((tax) => tax.label === item.label);
        return exists ? prevTaxes : [...prevTaxes, newTax];
      });
      setTaxData((prevTaxData) => {
        const updatedTaxData = [...prevTaxData];
        updatedTaxData[index] = {
          ...updatedTaxData[index],
          name: value.name,
        };
        return updatedTaxData;
      });
    }
  };

  const handleSaveAndExport = async () => {
    if (taxes.length === 0) {
      Toast({ message: 'Need to select atleast one tax', variant: 'error' });
      return;
    }
    const payload = {
      credentialId,
      taxMapping: taxes,
      newCredential: null,
    };
    if (isEditing) {
      const result = await updateCredentialData({
        id: currentData.id,
        payload: { tax_mapping: taxes },
        type: null,
      });
      if (result) {
        setIsEditing(false);
      }
    } else {
      const credential = await createManualAuthCredential(payload, true);
      if (credential) {
        if (!isSetting) {
          if (isManual) {
            await documentExportFunc(invoiceIds, 'Manual', credentialId);
            handleNewAndExport();
          } else {
            handleNewAndExport(
              newCredential,
              exportType,
              accountSetter,
              setLoader,
            );
          }
        }
      }
    }

    sessionStorage.removeItem('invoiceId');
    closePopup();
  };
  return (
    <OdooPopup open={openTaxPopup}>
      <DialogHeader style={{ display: 'flex', alignItems: 'center' }}>
        Tax Mapping
      </DialogHeader>
      {isEditing && (
        <CustomCloseIcon aria-label="close" onClick={closePopup}>
          <CloseIcon />
        </CustomCloseIcon>
      )}
      <TallyPrimeContent>
        <Stepper sx={{ marginTop: 2 }} activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Divider sx={{ marginTop: 1 }} />
        <CustomDialogContentTax>
          <DialogContentText>
            {activeStep === 1 && (
              <Grid container rowGap={4}>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Box>
                    <Typography variant="h5">Map Tax</Typography>
                    <Typography variant="body2">
                      How to add IP Address for more information
                    </Typography>
                  </Box>
                  <Box>
                    <AddTaxButton
                      startIcon={<AddIcon />}
                      onClick={handleAddTaxClick}
                    >
                      Add More Tax
                    </AddTaxButton>
                  </Box>
                </Grid>
                <Grid container spacing={1} columnSpacing={4}>
                  {taxData.map((item, index) => (
                    <TaxGrid item xs={12} sm={12} lg={6} key={item.label}>
                      <Box>
                        <Typography color="#9F77EB">{item.label}</Typography>
                      </Box>
                      <Box display="flex" gap={1}>
                        <FormControlStyledComponent size="small">
                          <AutocompleteTaxMapping
                            id="demo-simple-autocomplete"
                            options={taxOptions}
                            value={item}
                            getOptionLabel={(option) => {
                              if (typeof option === 'string') {
                                return option;
                              }
                              return option?.name || '';
                            }}
                            getOptionSelected={(option, value) => {
                              if (!value) {
                                return false;
                              }
                              if (typeof value === 'string') {
                                return option.name === value;
                              }
                              return option.name === value.name;
                            }}
                            onChange={(e, newValue) =>
                              handleChangeTax(newValue, item, index)
                            }
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" />
                            )}
                          />
                        </FormControlStyledComponent>
                        <TaxDeleteIconButton
                          aria-label="delete"
                          size="small"
                          onClick={() => handleDelete(index)}
                        >
                          <Trash />
                        </TaxDeleteIconButton>
                      </Box>
                    </TaxGrid>
                  ))}
                </Grid>
                {error && (
                  <Typography style={{ color: 'red', marginBottom: '10px' }}>
                    {error}
                  </Typography>
                )}
              </Grid>
            )}
            {showTaxFields && (
              <Box display="flex" alignItems="center" gap={1} mt={2}>
                <InputGroup
                  id="select-text-field"
                  size="small"
                  type="number"
                  value={fieldValue.taxRate}
                  inputProps={{
                    min: 0,
                    max: 99,
                  }}
                  onChange={(e) =>
                    setFieldValue({ ...fieldValue, taxRate: e.target.value })
                  }
                  startAdornment={
                    <InputAdornmentStyleComponent position="start">
                      <Box display="flex" alignItems="center" padding={0}>
                        <Select
                          displayEmpty
                          variant="standard"
                          disableUnderline
                          value={fieldValue.label}
                          onChange={(e) =>
                            setFieldValue({
                              ...fieldValue,
                              label: e.target.value,
                            })
                          }
                          style={{
                            minWidth: '70px',
                            backgroundColor: '#f5f5f5',
                            paddingLeft: 8,
                            paddingRight: 8,
                          }}
                        >
                          <MenuItem value="SGST">SGST</MenuItem>
                          <MenuItem value="CGST">CGST</MenuItem>
                          <MenuItem value="IGST">IGST</MenuItem>
                          <MenuItem value="TAX">TAX</MenuItem>
                        </Select>
                        <Divider
                          orientation="vertical"
                          flexItem
                          style={{ margin: '0 2px' }}
                        />
                      </Box>
                    </InputAdornmentStyleComponent>
                  }
                  endAdornment={
                    <InputAdornmentStyleComponent position="end">
                      %
                    </InputAdornmentStyleComponent>
                  }
                  style={{ paddingLeft: 0 }}
                />
                <Select
                  size="small"
                  style={{ minWidth: 140 }}
                  displayEmpty
                  input={<OutlinedInput />}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: '20vh',
                      },
                    },
                  }}
                >
                  {taxOptions.map((option) => (
                    <MenuItem value={option} key={option.value}>
                      {option.value}
                    </MenuItem>
                  ))}
                </Select>
                <TaxDeleteIconButton
                  color="primary"
                  onClick={handleNewTaxChange}
                >
                  <CheckIcon />
                </TaxDeleteIconButton>
                <TaxDeleteIconButton
                  color="primary"
                  onClick={handleCloseTaxChange}
                >
                  <CloseIcon />
                </TaxDeleteIconButton>
              </Box>
            )}
          </DialogContentText>
        </CustomDialogContentTax>
        <DialogActions>
          <Box className="actionButtonBox">
            <SaveButton variant="contained" onClick={handleSaveAndExport}>
              <Typography variant="body1">{actionLabel}</Typography>
            </SaveButton>
          </Box>
        </DialogActions>
      </TallyPrimeContent>
    </OdooPopup>
  );
});
TaxMapping.propTypes = {
  exportType: PropTypes.bool.isRequired,
  credentialId: PropTypes.func.isRequired,
  handleNewAndExport: PropTypes.func.isRequired,
  invoiceIds: PropTypes.arrayOf.isRequired,
  newCredential: PropTypes.shape({}).isRequired,
  isManual: PropTypes.bool.isRequired,
  documentExportFunc: PropTypes.func.isRequired,
  openTaxPopup: PropTypes.bool.isRequired,
  closePopup: PropTypes.func.isRequired,
  accountSetter: PropTypes.func.isRequired,
  setLoader: PropTypes.func.isRequired,
  isSetting: PropTypes.bool.isRequired,
  currentData: PropTypes.shape({
    id: PropTypes.string,
    tax_mapping: PropTypes.arrayOf.isRequired,
    credential: PropTypes.shape({}),
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};
export default TaxMapping;
